export const PENDING_AUTH_METHOD_KEY = 'cm_pending_auth_method';
